import {createRouter, createWebHashHistory} from 'vue-router';

// utils/updateFavicon.js
export function updateFavicon(iconUrl) {
    let link = document.querySelector("link[rel='icon']");

    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }

    link.href = iconUrl;
}

// 路由配置
const routes = [{
    path: '/', redirect: '/ldxy/puzzle'
}, {
    path: '/ldxy/puzzle', name: '乱斗西游 2', component: () => import('@/views/ldxy/PuzzleQuestion/index.vue'), meta: {
        title: '乱斗西游 2', favicon: '/favicon.ico'
    }
}, {
    path: '/ldxy/coin', name: '凌云壁', component: () => import('@/views/ldxy/LdxyCoin/index.vue'), meta: {
        title: '凌云壁', favicon: '/favicon.ico'
    }
}, {
    path: '/abo/series', name: '保卫萝卜', component: () => import('@/views/abo/CarrotSeries/index.vue'), meta: {
        title: '保卫萝卜', favicon: '/abo.ico'
    },
}, {
    path: '/abo/limited', name: '保卫萝卜发行', component: () => import('@/views/abo/CarrotLimited/index.vue'), meta: {
        title: '保卫萝卜限定系列'
    },
}, {
    path: '/abo/figure', name: '保卫萝卜单体', component: () => import('@/views/abo/CarrotFigure/index.vue'), meta: {
        title: '保卫萝卜限定系列', favicon: '/abo.ico'
    },
}, {
    path: '/abo/fantasy', name: '保卫萝卜家族', component: () => import('@/views/abo/CarrotFantasy/index.vue'), meta: {
        title: '保卫萝卜限定系列', favicon: '/abo.ico'
    },
}, {
    path: '/mxd/version', name: '冒险岛版本', component: () => import('@/views/mxd/Version/index.vue'), meta: {
        title: '冒险岛版本', favicon: '/mxd.ico'
    },
}, {
    path: '/tools/mortgage', name: '房奴劝退器', component: () => import('@/views/tools/Mortgage/index.vue'), meta: {
        title: '房奴劝退器'
    },
}, {
    path: '/tools/jlpt', name: '日本語能力試験', component: () => import('@/views/tools/Nihonngo/index.vue'), meta: {
        title: '日本語能力試験', favicon: '/jlpt.ico'
    },
}, {
    path: '/tmp/table', name: 'Table', component: () => import('@/views/tmp/Table/index.vue'), meta: {
        title: 'Table'
    },
}, {
    path: '/tmp/temp', name: 'Temp', component: () => import('@/views/tmp/Temp/index.vue'), meta: {
        title: 'Temp'
    },
}, {
    path: '/tmp/card', name: 'Card', component: () => import('@/views/tmp/Card/index.vue'), meta: {
        title: 'Card'
    },
}, {
    path: '/data/trade', name: '中美贸易', component: () => import('@/views/data/TradeStats/index.vue'), meta: {
        title: '中美贸易'
    },
}, {
    path: '/data/income', name: '居民收入分布', component: () => import('@/views/data/IncomeStats/index.vue'), meta: {
        title: '居民收入分布'
    },
}, {
    path: '/ele/basic/button', name: 'Button 按钮', component: () => import('@/views/ele/Basic/Button/index.vue')
}, {
    path: '/zsk/article', name: '知识库', component: () => import('@/views/zsk/Article/index.vue')
}, {
    path: '/zsk/article/:id', name: '知识库详细', component: () => import('@/views/zsk/ArticleDetail/index.vue')
}];

// 创建路由实例
const router = createRouter({
    history: createWebHashHistory(), routes,
});

router.afterEach((to) => {
    if (window.umami) {
        window.umami.track(to.fullPath)
    }
})

// 全局路由守卫（可选）
router.beforeEach((to, from, next) => {
    // 动态设置页面标题
    document.title = to.meta.title || '默认标题';
    updateFavicon(to.meta.favicon || '/favicon.ico');
    next();

    window.umami.trackEvent('页面跳转', {
        path: to.path, name: to.name
    });
});

export default router;
